import { useState } from 'react'

import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'
import { Link } from '@tribeplatform/react-ui-kit/Link'
import { Popover } from '@tribeplatform/react-ui-kit/Popover'

import { T } from '../i18n/components/T.js'

import { SpacePathPicker } from './SpacePathPicker.js'

interface Props {
  value: string
  label?: JSX.Element | string
  name: string
  placeholder?: string
  helperText?: JSX.Element | string
  onChange: (value: string) => void
}
export const LinkPicker = ({
  value,
  label,
  name,
  placeholder,
  helperText,
  onChange,
}: Props) => {
  const [open, setOpen] = useState(false)

  const handleChange = (path: string) => {
    onChange(path)
    setOpen(false)
  }
  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between">
        <FormControl.Label>{label}</FormControl.Label>
        <div className="text-sm font-normal">
          <Popover
            open={open}
            onClose={() => setOpen(false)}
            padding="sm"
            placement="bottom"
            className="max-h-none"
            activator={
              <Link variant="accent" onClick={() => setOpen(true)}>
                <T
                  defaultMessage="Select {SPACE}"
                  id="LinkPicker.SelectSpace"
                />
              </Link>
            }
          >
            <Popover.Content className="w-full">
              <SpacePathPicker onSelect={handleChange} />
            </Popover.Content>
          </Popover>
        </div>
      </div>
      <FormControl.Input
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={e => handleChange(e.target.value)}
        helperText={helperText}
      />
    </div>
  )
}
